/* Впровадження (internal/rollout). Kept apart from uk.ts/en.ts to keep merges small. */
export const rolloutUk = {
  'nav.implementation': 'Впровадження',
  'rollout.title': 'Впровадження',
  'rollout.subtitle': 'План запуску системи по етапах: що вже впроваджено і чи справді цим користуються співробітники.',
  'rollout.subtitleMine': 'Етапи впровадження, за які ви відповідаєте.',
  'rollout.compute': 'Перерахувати показники',
  'rollout.computed': 'Показники оновлено: {met} з {measured} на цілі.',
  'rollout.lastComputed': 'Показники: {when}',
  'rollout.neverComputed': 'Показники ще не рахувались',
  'rollout.overall': 'Уся система',
  'rollout.progressN': '{done} з {total} етапів',
  'rollout.inProgressN': 'У роботі: {n}',
  'rollout.unusedN': 'Не використовуються: {n}',
  'rollout.adoptionOkN': 'Використовуються на цілі: {n} з {m}',
  'rollout.advice': 'Поради',
  'rollout.adviceEmpty': 'Усі етапи на своїх місцях — нових порад немає.',
  'rollout.advice.next': 'Далі',
  'rollout.advice.unused': 'Не використовується',
  'rollout.advice.overdue': 'Прострочено',
  'rollout.advice.waiting': 'Очікує',
  'rollout.filter.phase': 'Фаза',
  'rollout.filter.allPhases': 'Усі фази',
  'rollout.filter.status': 'Статус',
  'rollout.filter.allStatuses': 'Усі статуси',
  'rollout.filter.resp': 'Відповідальний',
  'rollout.filter.anyone': 'Будь-хто',
  'rollout.filter.nobody': 'Без відповідального',
  'rollout.filter.problems': 'Лише проблеми',
  'rollout.filter.mine': 'Мої',
  'rollout.filter.feature': 'Розділ: {f}',
  'rollout.filter.clearFeature': 'Показати всі розділи',
  'rollout.empty': 'Немає етапів за цими фільтрами',
  'rollout.emptyMine': 'Вам ще не доручили жодного етапу впровадження.',
  'rollout.status.not_started': 'Не почато',
  'rollout.status.in_progress': 'У роботі',
  'rollout.status.done': 'Впроваджено',
  'rollout.status.skipped': 'Пропущено',
  'rollout.status.blocked': 'Заблоковано',
  'rollout.unused': 'Впроваджено, але не використовується',
  'rollout.problem.overdue': 'Строк минув',
  'rollout.problem.blocked': 'Заблоковано',
  'rollout.problem.prereqs': 'Спершу попередні етапи',
  'rollout.suggestDone': 'Показники на цілі — можна позначити «Впроваджено»',
  'rollout.noResponsible': 'Не призначено',
  'rollout.checklistN': 'Чекліст {done}/{total}',
  'rollout.effort': '≈ {h} год',
  'rollout.adoption.none': 'Ще немає даних',
  'rollout.adoption.manual': 'Перевіряється вручну',
  'rollout.adoption.score': 'Використання {n}%',
  'rollout.dragHint': 'Перетягуйте етапи, щоб змінити порядок; залежності лише попереджають.',
  'rollout.drag': 'Перетягнути: {title}',
  'rollout.moveUp': 'Вище',
  'rollout.moveDown': 'Нижче',
  'rollout.moved': 'Порядок збережено',
  'rollout.drawer.open': 'Відкрити розділ',
  'rollout.drawer.help': 'Довідка',
  'rollout.drawer.status': 'Статус',
  'rollout.drawer.statusNote': 'Причина (для «Пропущено» і «Заблоковано»)',
  'rollout.drawer.responsible': 'Відповідальний',
  'rollout.drawer.target': 'Цільова дата',
  'rollout.drawer.owner': 'Хто відповідає в бізнесі',
  'rollout.drawer.prereqs': 'Попередні етапи',
  'rollout.drawer.prereqsMissing': 'Ще не виконано: {list}. Це попередження — етап можна вести далі.',
  'rollout.drawer.checklist': 'Чекліст',
  'rollout.drawer.signals': 'Показники використання',
  'rollout.drawer.target_short': 'ціль {cmp} {v}',
  'rollout.drawer.window': 'за {n} дн.',
  'rollout.drawer.noData': 'немає подій за період',
  'rollout.drawer.manual': 'Автоматичного показника немає: {reason}',
  'rollout.drawer.who': 'Хто не використовує',
  'rollout.drawer.whoHint': 'За 7 днів: відкриття сторінок і дії в розділі. Спершу ті, хто мав би користуватися, але не користується.',
  'rollout.drawer.whoSince': 'Відкриття сторінок рахуються з {d}; раніше — лише дії.',
  'rollout.drawer.roles': 'За ролями',
  'rollout.drawer.visits': 'Відкриттів',
  'rollout.drawer.actions': 'Дій',
  'rollout.drawer.last': 'Востаннє',
  'rollout.drawer.notUsing': 'не користується',
  'rollout.drawer.notes': 'Нотатки',
  'rollout.drawer.saveNotes': 'Зберегти нотатки',
  'rollout.drawer.history': 'Історія',
  'rollout.drawer.warnings': 'Збережено з попередженням',
  'rollout.history.status': 'Статус: {from} → {to}',
  'rollout.history.reorder': 'Порядок: позиція {n}',
  'rollout.history.assign': 'Відповідальний: {name}',
  'rollout.history.target': 'Цільова дата: {d}',
  'rollout.history.notes': 'Нотатки змінено',
  'rollout.history.tick': 'Відмічено пункт чекліста',
  'rollout.history.untick': 'Знято позначку з пункту',
  'rollout.history.alert': 'Нагадування: розділом не користуються',
  'rollout.trend.up': 'зростає',
  'rollout.trend.down': 'падає',
  'rollout.trend.flat': 'без змін',
}

export const rolloutEn: Record<keyof typeof rolloutUk, string> = {
  'nav.implementation': 'Rollout',
  'rollout.title': 'Rollout',
  'rollout.subtitle': 'The step-by-step plan to roll the system out: what is implemented and whether staff really use it.',
  'rollout.subtitleMine': 'Rollout stages you are responsible for.',
  'rollout.compute': 'Recompute signals',
  'rollout.computed': 'Signals updated: {met} of {measured} at target.',
  'rollout.lastComputed': 'Signals: {when}',
  'rollout.neverComputed': 'Signals not computed yet',
  'rollout.overall': 'Whole system',
  'rollout.progressN': '{done} of {total} stages',
  'rollout.inProgressN': 'In progress: {n}',
  'rollout.unusedN': 'Not used: {n}',
  'rollout.adoptionOkN': 'Used at target: {n} of {m}',
  'rollout.advice': 'Advice',
  'rollout.adviceEmpty': 'Everything is on track — no new advice.',
  'rollout.advice.next': 'Next',
  'rollout.advice.unused': 'Not used',
  'rollout.advice.overdue': 'Overdue',
  'rollout.advice.waiting': 'Waiting',
  'rollout.filter.phase': 'Phase',
  'rollout.filter.allPhases': 'All phases',
  'rollout.filter.status': 'Status',
  'rollout.filter.allStatuses': 'All statuses',
  'rollout.filter.resp': 'Responsible',
  'rollout.filter.anyone': 'Anyone',
  'rollout.filter.nobody': 'Nobody assigned',
  'rollout.filter.problems': 'Problems only',
  'rollout.filter.mine': 'Mine',
  'rollout.filter.feature': 'Feature: {f}',
  'rollout.filter.clearFeature': 'Show all features',
  'rollout.empty': 'No stages match these filters',
  'rollout.emptyMine': 'No rollout stage is assigned to you yet.',
  'rollout.status.not_started': 'Not started',
  'rollout.status.in_progress': 'In progress',
  'rollout.status.done': 'Implemented',
  'rollout.status.skipped': 'Skipped',
  'rollout.status.blocked': 'Blocked',
  'rollout.unused': 'Implemented but not used',
  'rollout.problem.overdue': 'Overdue',
  'rollout.problem.blocked': 'Blocked',
  'rollout.problem.prereqs': 'Prerequisites first',
  'rollout.suggestDone': 'Signals at target — you can mark it implemented',
  'rollout.noResponsible': 'Not assigned',
  'rollout.checklistN': 'Checklist {done}/{total}',
  'rollout.effort': '≈ {h} h',
  'rollout.adoption.none': 'No data yet',
  'rollout.adoption.manual': 'Checked manually',
  'rollout.adoption.score': 'Adoption {n}%',
  'rollout.dragHint': 'Drag stages to change the order; dependencies only warn.',
  'rollout.drag': 'Drag: {title}',
  'rollout.moveUp': 'Up',
  'rollout.moveDown': 'Down',
  'rollout.moved': 'Order saved',
  'rollout.drawer.open': 'Open the page',
  'rollout.drawer.help': 'Help',
  'rollout.drawer.status': 'Status',
  'rollout.drawer.statusNote': 'Reason (for skipped and blocked)',
  'rollout.drawer.responsible': 'Responsible',
  'rollout.drawer.target': 'Target date',
  'rollout.drawer.owner': 'Business owner',
  'rollout.drawer.prereqs': 'Prerequisites',
  'rollout.drawer.prereqsMissing': 'Not done yet: {list}. This is a warning — the stage can go on.',
  'rollout.drawer.checklist': 'Checklist',
  'rollout.drawer.signals': 'Adoption signals',
  'rollout.drawer.target_short': 'target {cmp} {v}',
  'rollout.drawer.window': 'over {n} d',
  'rollout.drawer.noData': 'no events in the period',
  'rollout.drawer.manual': 'No automatic signal: {reason}',
  'rollout.drawer.who': 'Who does not use it',
  'rollout.drawer.whoHint': 'Last 7 days: page visits and actions in this feature. People who should use it but do not come first.',
  'rollout.drawer.whoSince': 'Page visits are counted since {d}; earlier only actions.',
  'rollout.drawer.roles': 'By role',
  'rollout.drawer.visits': 'Visits',
  'rollout.drawer.actions': 'Actions',
  'rollout.drawer.last': 'Last',
  'rollout.drawer.notUsing': 'not using',
  'rollout.drawer.notes': 'Notes',
  'rollout.drawer.saveNotes': 'Save notes',
  'rollout.drawer.history': 'History',
  'rollout.drawer.warnings': 'Saved with a warning',
  'rollout.history.status': 'Status: {from} → {to}',
  'rollout.history.reorder': 'Order: position {n}',
  'rollout.history.assign': 'Responsible: {name}',
  'rollout.history.target': 'Target date: {d}',
  'rollout.history.notes': 'Notes changed',
  'rollout.history.tick': 'Checklist item ticked',
  'rollout.history.untick': 'Checklist item unticked',
  'rollout.history.alert': 'Reminder: the feature is not used',
  'rollout.trend.up': 'rising',
  'rollout.trend.down': 'falling',
  'rollout.trend.flat': 'flat',
}
